import { render, staticRenderFns } from "./AracUzerindekiHacizSerhininKaldirilmasiTalepEvrakForm.vue?vue&type=template&id=48782a40"
import script from "./AracUzerindekiHacizSerhininKaldirilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./AracUzerindekiHacizSerhininKaldirilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports